import { render, staticRenderFns } from "./ModalProjectSelect.vue?vue&type=template&id=2b3a2ae5&scoped=true"
import script from "./ModalProjectSelect.vue?vue&type=script&lang=js"
export * from "./ModalProjectSelect.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectSelect.vue?vue&type=style&index=0&id=2b3a2ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a2ae5",
  null
  
)

export default component.exports